/**
 * Remembers that this browser session queued a report.
 *
 * GenerateReportV2 only queues the report and the file comes back as a
 * notification over SignalR, so the notification handler needs to know whether
 * the user is actually waiting for one before announcing it as ready.
 *
 * The flag lives in the module (not Redux) because it is per tab and must not
 * survive a reload: a report queued an hour ago should not turn an unrelated
 * notification into a "your report is ready" toast.
 */

/** A queued report is only expected back for this long */
const WAIT_WINDOW_MS = 10 * 60 * 1000;

let queuedAt: number | null = null;

/** Called right after the server accepts the report request */
export const markReportQueued = () => {
  queuedAt = Date.now();
};

/**
 * True for the first notification that arrives while this session is waiting.
 * Clears the wait, so only one notification is announced per queued report.
 */
export const consumeQueuedReport = (): boolean => {
  if (queuedAt === null) {
    return false;
  }
  const isWithinWindow = Date.now() - queuedAt < WAIT_WINDOW_MS;
  queuedAt = null;
  return isWithinWindow;
};
